import * as u from "./utils.js";
import * as n from "./number.js";
import { isDev, isProd } from "@/app.config.js";

export { isDev, isProd };

export const {
  toast,
  debounce,
  throttle,
  router,
  HOME_PAGE,
  onRouteFail,
  getUrlParams,
  formatNumberUnit,
  fixedNumber,
  formatModificationNumber,
  truncateNumber,
  formatDate,
  formatDateOnly,
  DATE_FORMAT,
  DATE_TIME_FORMAT,
} = u;

export default {
  isDev,
  isProd,
  ...u,
  ...n,
};
